"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Html_1 = __importDefault(require("components/Html"));
const translate_1 = require("components/translate");
const File_1 = require("helpers/File");
const UploadInfo = ({ maxFileSize, multiple = false, t }) => {
    const labelPath = multiple ? 'files.player' : 'files.player.single';
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _text-gray-800 _p-4", children: [(0, jsx_runtime_1.jsx)(Html_1.default, { children: t(`${labelPath}.extensions_v3`, {
                    fallback: `${labelPath}.extensions_v2`
                }) }), (0, jsx_runtime_1.jsx)(Html_1.default, { children: t(`${labelPath}.max_size`, {
                    data: { size: (0, File_1.formatBytes)(maxFileSize) }
                }) })] }));
};
exports.default = (0, translate_1.translate)()(UploadInfo);
